import Immutable from 'app/utils/immutable/Immutable';

import {
    LOAD_CUSTOM_EMOJIS,
    UPSERT_CUSTOM_EMOJI,
    REMOVE_CUSTOM_EMOJI,
} from 'store/actions/chat/chatActions';

const initialState = {
    custom: [],
    isLoading: false,
    loadedAt: null,
};

const upsert = (list, emoji) => {
    if (!emoji || !emoji._id) return list;
    const idx = list.findIndex(e => e._id === emoji._id);
    if (idx < 0) return [...list, emoji];
    return [...list.slice(0, idx), { ...list[idx], ...emoji }, ...list.slice(idx + 1)];
};

const removeById = (list, id) => list.filter(e => e._id !== id);

export default (state = initialState, action) => {
    const { type, payload, error } = action;
    switch (type) {
        case LOAD_CUSTOM_EMOJIS:
            if (error) return Immutable({ ...state, isLoading: false });
            return Immutable({ ...state, custom: payload || [], isLoading: false, loadedAt: new Date().toISOString() });
        case UPSERT_CUSTOM_EMOJI:
            return Immutable({ ...state, custom: upsert(state.custom, payload) });
        case REMOVE_CUSTOM_EMOJI:
            return Immutable({ ...state, custom: removeById(state.custom, payload) });
        default:
            return state;
    }
};
